import React, { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  COMPANY_ONBOARDING_PATH,
  fetchCompanyOnboardingStatus,
} from '../../utils/companyRouting';

/**
 * Redirects company users without a profile to onboarding before showing children.
 */
export default function CompanyOnboardingRouteGuard({ children }) {
  const { user, token, authLoading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (authLoading) return;

    if (!token || !user) {
      navigate('/login', { replace: true });
      return;
    }

    if (user.role !== 'company') {
      navigate('/dashboard', { replace: true });
      return;
    }

    let cancelled = false;

    (async () => {
      const status = await fetchCompanyOnboardingStatus(token);
      if (cancelled) return;
      if (status === null) {
        navigate('/login', { replace: true });
        return;
      }
      if (!status.has_company) {
        navigate(COMPANY_ONBOARDING_PATH, { replace: true });
        return;
      }
      setChecking(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [authLoading, token, user, navigate]);

  if (authLoading || checking) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status" data-testid="rwm-company-guard-loading">
          <span className="visually-hidden">Loading…</span>
        </Spinner>
      </Container>
    );
  }

  return children;
}
